import { fg } from '@atlassian/jira-feature-gating';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { ForPaintServicedeskSidebar as AsyncForPaintSidebarServiceDesk } from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { queuesNavigationItems } from '@atlassian/jira-router-resources-service-desk-queues/src/services/index.tsx';
import { issueNavigatorProjectListServicedeskRoute } from '@atlassian/jira-router-routes-issue-navigator-routes/src/issueNavigatorProjectListServicedeskRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { ProjectIssueNavigatorSkeleton } from '@atlassian/jira-skeletons/src/ui/issue-navigator/components/project-app.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@atlassian/jira-capabilities/src/constants.tsx';
import { jsmProjectMenuContentSidebarResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/jsm-customize-sidebar/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { staticSidebarDefaultPINFiltersResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/project-filters/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { getAIContextPanelResources } from '@atlassian/jira-servicedesk-ai-context-panel-resources/src/services/index.tsx';
import { getCommonProjectResources } from './common/getCommonProjectResources.tsx';
import { getRouteReporting } from './common/getRouteReporting.tsx';
import { issueNavigatorWithoutHorizontalNavPageEntryPoint } from './ui/index.tsx';

const getAIContextPanelResourcesWithCondition = () =>
	fg('empanada_nin_resource_audit_2025') ? getAIContextPanelResources() : [];

/**
 * Servicedesk Project Issue Navigator Route Entry
 * Handles JSM (Service management) projects, also known JSD (Servicedesk) projects.
 */
export const issueNavigatorProjectListServicedeskRouteEntry = createEntry(
	issueNavigatorProjectListServicedeskRoute,
	() => ({
		ufoName: 'jsm-list-nin',
		group: 'issue-navigator',
		meta: {
			capability: NIN_NEW_ISSUE_NAVIGATOR,
			reporting: getRouteReporting(),
		},
		skeleton: ProjectIssueNavigatorSkeleton,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncForPaintSidebarServiceDesk,
		},
		resources: [
			...getCommonProjectResources(),
			queuesNavigationItems,
			resourceWithCondition2(
				() => !fg('empanada_nin_resource_audit_2025'),
				getConsolidationStateResource(),
			),
			resourceWithCondition2(
				() => fg('more_for_nav_4_level_3'),
				jsmProjectMenuContentSidebarResource,
			),
			resourceWithCondition2(
				() => fg('empanada_nin_resource_audit_2025'),
				forgeProjectModuleResource,
			),
			resourceWithCondition2(
				() => fg('empanada_nin_resource_audit_2025'),
				staticProjectSidebarConnectAddonsNavigationResource,
			),
			resourceWithCondition2(
				() => fg('empanada_nin_resource_audit_2025'),
				staticSidebarDefaultPINFiltersResource,
			),
			...getAIContextPanelResourcesWithCondition(),
		],
		layout: serviceProjectLayout,
		bifrost: {
			bifrostGroup: 'issue-navigator',
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectListServicedeskRouteEntry.tsx',
				whichExportToUse: 'issueNavigatorProjectListServicedeskRouteEntry',
			},
			manifestName: 'jira-spa-issue-navigator.json',
			enabled: true,
		},
		entryPoint: () => issueNavigatorWithoutHorizontalNavPageEntryPoint,
		supportsPreviewPanel: true,
		isHydrateRootEnabled: fg('nin-full-page-hydrate-root'),
	}),
);
